<ul class="sub-list region-list" *ngIf="sports && sports.length > 0">
  <li *ngFor="let sport of sports;" (click)="selectSport(sport.id); $event.stopPropagation();"
  [class.no-border]="sport.specialOfferType">
    <div class="competition-info" *ngIf="pageType != pageTypeEnum.Prematch">
      <!-- show eod and sb by sport -->
      <!-- <div class="competition-info"> -->
      <div class="name-wrap">
        <i class="icon-sm m-r s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}"></i>
        <span class="region-name">{{sport.name}}</span>
      </div>
      <div class="events-count">
        <!-- <span *ngIf="pageType === pageTypeEnum.Prematch">{{sport.eventsCount}}</span> -->
        <i class="arrow-down icon icon-xs icon-chevron-down" [class.closed]="selectedSportId === sport.id"></i>
      </div>
    </div>
    <section class="events-main-wrap" (click)="$event.stopPropagation();"
      *ngIf="(selectedSportId === sport.id || pageType == pageTypeEnum.Prematch) && eventsForSelectedSport[sport.id] && eventsForSelectedSport[sport.id].length >0">
      <div class="event-wrap" [class.expanded]="event.isExpanded"
        *ngFor="let event of eventsForSelectedSport[sport.id]; let j = index">
        <div class="row event-info">
          <div class="name-wrap">
            <i *ngIf="sport.specialOfferType" class="icon-sm s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}"></i>
            <div class="name">{{event.eventName}} </div>
            <div class="super-bet" *ngIf="event.mappingType == eventsMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</div>
            <div class="event-of-day" *ngIf="event.mappingType == eventsMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</div>
          </div>
          <div class="date-time">{{event.eventDate}} {{event.eventTime}}</div>
        </div>
        <article class="row" *ngIf="!event.isExpanded">
          <div class="bet-type-wrap" *ngIf="event.eventType != eventTypeEnum.Outright; else outright">
            <ng-container *ngIf="selectionsForSelectedSport[sport.id] && selectionsForSelectedSport[sport.id][0]; let selection">
              <ng-container
                *ngIf="event.betGroups[selection.betTypeId] && event.betGroups[selection.betTypeId].betToShow else emptyBet">
                <div class="bet-type-col">
                  <ng-container *ngFor="let betTypeOutcome of selection.betTypeOutcomes; let i = index;">
                    <ng-container
                      *ngIf="event.betGroups[selection.betTypeId].betToShow.betOutcomesDic[betTypeOutcome.id] && event.betGroups[selection.betTypeId].betToShow.betOutcomesDic[betTypeOutcome.id][0]; let betOutcome">
                      <ng-container *ngIf="betOutcome.odd > 1 && betOutcome.isPlayable; else emptyOutcome">
                        <div class="outcome-wrap" [@blink-border]="betOutcome.odd"
                          [ngClass]="{'selected': betOutcome.isSelected}"
                          (click)="toggleEventOutcome(event, event.betGroups[selection.betTypeId].betToShow, betOutcome, betTypeOutcome.name, selection.betTypeName);">
                          <span class="outcome-name">
                          <ng-container *ngIf="event.eventType == eventTypeEnum.HeadToHead">{{betTypeOutcome.name}} </ng-container>
                          <ng-container *ngIf="selection.sbvDispalyType == sbvDisplayTypeEnum.SBVInOutcome && event.betGroups[selection.betTypeId].betToShow.sbv">
                            <ng-container *ngIf="!event.betGroups[selection.betTypeId].betToShow.sbv.useSbvHandicapPipe">{{event.betGroups[selection.betTypeId].betToShow.sbv.sbv}}</ng-container>
                            <ng-container *ngIf="event.betGroups[selection.betTypeId].betToShow.sbv.useSbvHandicapPipe">{{event.betGroups[selection.betTypeId].betToShow.sbv.sbv | handicapSbv}}</ng-container>
                          </ng-container>
                          </span>
                          <span class="outcome-odd">
                            {{betOutcome.odd | odd}}
                          </span>
                        </div>

                      </ng-container>

                    </ng-container>
                    <ng-template #emptyOutcome>
                      <div class="outcome-wrap">
                        <span class="outcome-name">{{betTypeOutcome.name}}</span>
                        <span class="outcome-odd locked">
                          <app-svg-icon iconId="lock"></app-svg-icon>
                        </span>
                      </div>
                    </ng-template>
                    <span class="sbv"
                      *ngIf="i==0 && selection.hasSBV && selection.sbvDispalyType != sbvDisplayTypeEnum.SBVInOutcome">
                      <ng-container *ngIf="!event.betGroups[selection.betTypeId].betToShow.sbv.useSbvHandicapPipe">{{event.betGroups[selection.betTypeId].betToShow.sbv.sbv}}</ng-container>
                      <ng-container *ngIf="event.betGroups[selection.betTypeId].betToShow.sbv.useSbvHandicapPipe">{{event.betGroups[selection.betTypeId].betToShow.sbv.sbv | handicapSbv}}</ng-container></span>
                  </ng-container>
                </div>
              </ng-container>

              <ng-template #emptyBet>
                <div class="bet-type-col">
                  <ng-container *ngFor="let i of arr(selection.betTypeOutcomes.length); let j = index">
                    <div class="outcome-wrap">
                      <!-- <span class="outcome-name">{{betTypeOutcome.name}}</span> -->
                      <span class="outcome-odd locked disabled offline">
                        <!-- null -->
                        <app-svg-icon iconId="lock"></app-svg-icon>
                      </span>
                      <span class="sbv" *ngIf="j==0 && selection.hasSBV">-</span>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
            </ng-container>

          </div>

          <ng-template #outright>
            <div class="bet-type-wrap">
              <div class="bet-type-col">
                <div class="outcome-wrap" (click)="showDetail(event);">
                  <span class="outcome-odd" i18n="Long term offer button@@LongTermOffer">
                    DUGOROCNA PONUDA
                  </span>
                </div>
              </div>
            </div>
          </ng-template>



          <div class="expand-event" (click)="showDetail(event);">+{{event.betsCount}}</div>
        </article>
      </div>
    </section>
  </li>
</ul>
